<template>
  <div class="go-nogo-progress">
    <div class="go-nogo-progress__header">
      <span class="go-nogo-progress__label go-nogo-progress__label--go">
        {{ goPercentage }}% {{ $t('go-nogo.go') }}
      </span>
      <span class="go-nogo-progress__count">{{
        $t('go-nogo.votes-cast', { cast: votesCount, invited: totalVotes })
      }}</span>
      <span class="go-nogo-progress__label go-nogo-progress__label--nogo">
        {{ nogoPercentage }}% {{ $t('go-nogo.nogo') }}
      </span>
    </div>
    <div class="go-nogo-progress__bar">
      <div class="go-nogo-progress__bar-go" :style="{ width: goPercentage + '%' }"></div>
      <div class="go-nogo-progress__bar-nogo" :style="{ width: nogoPercentage + '%' }"></div>
    </div>
  </div>
</template>

<script>
/** Extracted because it moves between two cards: the voting card, then the history card once locked. */
export default {
  name: 'GoNoGoVoteProgress',
  props: {
    goPercentage: { type: Number, default: 0 },
    nogoPercentage: { type: Number, default: 0 },
    votesCount: { type: Number, default: 0 },
    totalVotes: { type: Number, default: 0 },
  },
};
</script>

<style lang="scss">
.go-nogo-progress {
  display: flex;
  flex-direction: column;
  gap: 8px;

  &__header {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: baseline;
    gap: 12px;
  }

  &__label {
    font-size: $font-size-xxsmall;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;

    &--go {
      color: $color-green;
      text-align: left;
    }

    &--nogo {
      color: $color-error;
      text-align: right;
    }
  }

  &__count {
    color: $color-normal-pale;
    font-size: $font-size-xxsmall;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    text-align: center;
    font-variant-numeric: tabular-nums;
  }

  &__bar {
    display: flex;
    width: 100%;
    height: 10px;
    border-radius: $border-radius-large;
    overflow: hidden;
    background-color: $color-neutral-pale;
  }

  &__bar-go {
    background-color: $color-green;
    transition: width 200ms ease;
  }

  &__bar-nogo {
    background-color: $color-error;
    transition: width 200ms ease;
  }
}
</style>
